export default "__VITE_ASSET__BZH1tzNm__"